import React, { JSX } from 'react';
import { StyledButton } from './style';
import { SpaceProps } from 'styled-system';
import { ComposeType, StyledDiv } from '../../../Theme/CommonStyled';
import LoadingSpinner from '../LoadingSpinner';

type ButtonType = ComposeType & {
  children: JSX.Element | string;
  onClick: () => void;
  btnType?: 'primaryGreen' | 'green' | 'blue' | 'red';
  icon?: JSX.Element;
  loading?: boolean;
  disabled?: boolean;
};
const Button: React.FC<ButtonType> = ({
  children,
  onClick,
  btnType = 'primaryGreen',
  icon,
  loading,
  disabled,
  ...rest
}) => {
  return (
    <StyledButton
      onClick={onClick}
      btnType={btnType}
      disabled={loading || disabled}
      {...rest}>
      <StyledDiv position="absolute">
        {loading ? (
          <LoadingSpinner type={btnType} width={'15px'} height={'15px'} />
        ) : (
          icon || null
        )}
      </StyledDiv>
      <StyledDiv width="100%">{children}</StyledDiv>
    </StyledButton>
  );
};

export default Button;
